module.exports = __webpack_public_path__ + "img/logo.7e63b17e.png";